import type { TrainTranslations } from "./trainTranslations.types";

const trainUkTranslations: TrainTranslations = {
    trainPage: {
        title: "Train",
        step: "Step",
        resultsFound: "train options found",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Next step",
        loadingTimeline: "Loading timetable…",
    },
    widgetBreadcrumbs: {
        home: "Home",
        summary: "Summary",
        contact: "Contact details",
        payment: "Payment",
    },
    trainSortBy: {
        title: "Sort by",
        price_asc: "Lowest price first",
        price_desc: "Highest price first",
        fastest: "Fastest",
        fewest_changes: "Fewest changes"
    },
    trainBlock: {
        title: "Train Service",
        direct: "Direct"
    },
    trainFilters: {
        outboundTrip: {
            title: "Outbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "Destination station",
                time: "Arrival"
            }
        },
        inboundTrip: {
            title: "Inbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "",
                time: "Arrival"
            }
        },
        operators: "Operator",
        duration: "Journey duration"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille",
        PLY: "Paris - Gare de Lyon",
        PAZ: "Paris Gare d’Austerlitz",
        PEST: "Paris - Gare de l'Est",
        PARIS: "Paris - Gare de Lyon",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerp",
        BRU: "Brussels Midi",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        TNE: "Travelski Night Express",
        PEG: "Travelski Night Express",
        PEGASUS: "Travelski Night Express",
    },
    trainClass: {
        standard: "Eurostar Standard",
        premium: "Eurostar Plus",
        title: "Travel classes",
        outOfStock: "Out of stock"
    },
    trainClassCard: {
        yourTrain: "Your train",
        travelClass: "Your travel class",
        details: "Details",
        from: "From",
        included: "Included",
        select: "Select",
        classes: {
            seat: {
                title: "Seats",
                description: "Perfect seating option for a great-value trip (Seats do not incline)",
            },
            standard: {
                title: "Standard",
                description: "Standard sleeper with the essentials for the journey",
            },
            standardPlus: {
                title: "Standard plus",
                description: "Comfortable sleeper for a pleasant trip",
            },
            premiere: {
                title: "Premium",
                description: "A premium travel option for those looking for comfort.",
            },
        },
        criteria: {
            compartment6: "Compartment for 6",
            compartment4: "Compartment for 4",
            compartment3: "Compartment with 3 spaces",
            nonRecliningSeats: "Seats do not incline",
            electricalOutlet: "Electric socket",
            breakfastOptional: "Breakfast optional",
            sleepingBagSheet: "Bed sheet, duvet and pillow provided",
            storageSpace: "Storage space",
            comfortMattress: "Comfortable mattress topper",
            sheetDuvetPillow: "Sheet, duvet and pillowcase provided",
            storageNet: "Storage net",
            blackoutBlind: "Blackout blind",
            realBeds: "Beds, with sheets, duvet and pillowcase",
            premiumBedding: "Upgraded bedding",
            loungeSeats3: "3 seats",
            connectingCompartments: "Connecting compartments available",
            privateSink: "Private sink",
            largeStorage: "Large storage space",
            welcomeKit: "Welcome Kit",
        },
        subOptions: {
            individualBerths: {
                title: "2 individual couchettes",
                description: "Enjoy a unique experience travelling in a shared 6-person cabin.",
            },
            privateCompartment: {
                title: "Private compartment for 6",
                description: "Book an entire compartment, alone or with others, for your trip with family or friends.",
            },
            privateCompartmentStandardPlus: {
                title: "Private compartment for 6",
                description: "Book an entire compartment, alone or with others, for your trip with family or friends.",
            },
            privateCompartmentStandardPlus4: {
                title: "Private compartment for 4",
                description: "Book an entire compartment, alone or with others, for your trip with family or friends.",
            },
            privateCompartmentPremiere: {
                title: "Private compartment for 3",
                description: "Book an entire compartment, alone or with others, for your trip with family or friends.",
            },
            seat: {
                title: "Seated places",
                description: "A seated place ideal for a budget-friendly trip (non-reclining seats).",
            },
        },
        modal: {
            serviceTitle: "Service",
            services: {
                seat: {
                    breakfastOptional: "Breakfast optional",
                },
                standard: {
                    breakfastOptional: "Breakfast optional",
                },
                standardPlus: {
                    breakfastOptional: "Breakfast optional",
                    comfortKit: "Comfort kits: mattress topper + duvet (€5.50/person)",
                },
                premiere: {
                    breakfastOptional: "Breakfast optional",
                },
            },
        },
    }
};

export default trainUkTranslations;
